import { formatRankValue } from '../../../../../../helpers/format-rank-value'

import useStyles from './style'

const CustomDot = ({ cx, cy, payload, isRank = false }) => {
  const classes = useStyles()

  const chartHeight = 125
  const offset = 15

  const isNearBottom = cy > chartHeight - 40

  const textY = isNearBottom ? cy - offset : cy + offset
  const textAnchor = 'middle'
  const dominantBaseline = isNearBottom ? 'auto' : 'hanging'

  if (payload.value === null || payload.value === undefined) return null

  const numeric = Number(payload.value)
  const value = isRank ? formatRankValue(numeric) : numeric.toFixed(Number.isInteger(numeric) ? 0 : 2)

  return (
    <g className={classes.dot}>
      <circle cx={cx} cy={cy} r={6} fill="#fff" stroke="#111" strokeWidth={2} />
      <text x={cx} y={textY} textAnchor={textAnchor} dominantBaseline={dominantBaseline} fontSize={14} fill="#111">
        {value}
      </text>
    </g>
  )
}

export default CustomDot
